import React, { useEffect, useState } from 'react';
import { pageTitle } from '../PageTitle';
import HeaderOne from '../Header/HeaderTwo';
import FooterOne from '../Footer/FooterTwo';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import parse from 'html-react-parser';
import { fetchProject } from '../../DataFetchers/fetchProjects';


const ProjectsDetails = () => {
    pageTitle('Projects Details');
    const { search } = useLocation();
    const query = new URLSearchParams(search);
    const projectName = query.get('project');

    const [project, setProject] = useState(null);
    const [projectsData, setProjectsData] = useState([]);

    useEffect(() => {
        fetchProject(projectName).then((data) => {
            setProject(data.project);
            setProjectsData(data.others);
        });
    }, [projectName]);

    if(!project) return (<></>);

    return (

        <>
            <HeaderOne></HeaderOne>
            {/* <BreadCrumb></BreadCrumb> */}
            <section className="project__details p_relative">
                <div className="auto-container">
                    {project.wideImage && (
                        <div className="image">
                            <figure>
                                <img src={project.wideImage} alt="" />
                            </figure>
                        </div>
                    )}
                    <div className="pro__info">
                        <ul>
                            <li>
                                <div className="name">
                                    <p>Customer :</p>
                                </div>
                                <div className="name__two">
                                    <h4>{project.client}</h4>
                                </div>
                            </li>
                            {/* <li>
                                <div className="name">
                                    <p>Categories :</p>
                                </div>
                                <div className="name__two">
                                    <h4>{project.type}</h4>
                                </div>
                            </li> */}
                            <li>
                                <div className="name">
                                    <p>Year :</p>
                                </div>
                                <div className="name__two">
                                    <h4>{project.year}</h4>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className="data" style={{ textAlign: "center" }}>
                        <h4 className='yellow__text'>{parse(project.title)}</h4>
                        <p style={{ paddingBottom: "24px", fontWeight: '200' }}><b>Categories:</b> {project.type}</p>
                    </div>
                    <p>{parse(project.description)}</p>
                    {/* <div className="data">
                        <h4>Data Analysis and Business Intelligence</h4>
                        </div>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut laboreUt enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo con
                        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatuExcepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id esed ut perspiciatis unde omnis iste natus.</p>
                        <div className="data__list">
                            <ul>
                                <li> <i className="icon-05"></i>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                                <li> <i className="icon-05"></i>Mauris non est efficitur, porttitor dolor ut, euismod dui.</li>
                                <li> <i className="icon-05"></i>Nulla gravida sapien id turpis molestie, nec rhoncus quam accumsan.</li>
                                <li> <i className="icon-05"></i>Curabitur facilisis purus a ante feugiat cursus.</li>
                                <li> <i className="icon-05"></i>Suspendisse ut nisi ac lacus facilisis bibendum.</li>
                            </ul>
                        </div>
                        <div className="data__list">
                            <ul>
                                <li></li>
                            </ul>
                        </div>
                     */}

                    {/* <div className="project__button">
                    <div className="button__one">
                    <Link to="#">Previous</Link>
                    </div>
                    <div className="button__one">
                    <Link to="#">Next</Link>
                    </div>
                    </div> */}
                </div>
            </section>
            <div className="project__page p_relative see__pad">
                <div className="auto-container">
                    <h4 style={{ paddingBottom: "24px" }}>More like this...</h4>
                    <div className="row">
                        {projectsData.map((item, id) => (
                            <div className="col-lg-4 col-md-6 col-sm-12" key={id}>
                                <div className="portfolio__block p_relative">
                                    <div className="portfolio__image">
                                        <figure>
                                            <img alt="" />
                                        </figure>
                                    </div>
                                    <div className="lower__content p_absolute">
                                        <div className="protfolio__text">
                                            <div className="text__block">
                                                <h4>{item.name}</h4>
                                                <p>{item.type}</p>
                                            </div>
                                        </div>
                                        <div className="protfolio__button">
                                            <Link to={`/projects-details?project=${encodeURIComponent(item.name)}`} className="theme-btn theme-btn-one"> Read More<i className="icon-02"></i></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <FooterOne></FooterOne>
        </>
    );
};

export default ProjectsDetails;
